import type { Options } from '@/utils/loadable-retry/typings';

export default function retry<R>(
	fn: () => Promise<R>,
	{ retries = 3, interval = 500, exponentialBackoff = true }: Options = {},
) {
	return new Promise<R>((resolve, reject) => {
		fn()
			.then(resolve)
			.catch((error) => {
				setTimeout(() => {
					if (retries === 1) {
						reject(error);
						return;
					}

					// Passing on "reject" is the important part
					retry(fn, {
						retries: retries - 1,
						interval: exponentialBackoff ? interval * 2 : interval,
					}).then(resolve, reject);
				}, interval);
			});
	});
}
